module.exports = __webpack_public_path__ + "img/mq.db16eca9.svg";